export { default } from './search-bar-view';
